import TabView from '@/common/components/TabView.vue';
import { h } from 'vue';


export const createTabView = (tabs: Array<{
    path: string;
    title: string;
    icon: string;
    selectedIcon: string;
}>) => {
    return h(TabView as any, {
        tabs,
    });
};